/** ------ Events ------ */
/**
 * Event to fire/listen to after adding item to cart
 * @param {object} e
 * @param {object=} item
 * @param {object=} cartState
 * theme:onCartItemAdd (e, item, cartState)
 * */
/**
 * Event to fire/listen to after removing item from cart
 * @param {object} e
 * @param {object|undefined} item
 * @param {object|undefined} cartState
 * theme:onCartItemRemove (e, item, cartState)
 * */
/**
 * Event to fire/listen to after updating item in cart
 * @param {object} e
 * @param {object|undefined} item
 * @param {object|undefined} cartState
 * theme:onCartItemUpdate (e, item, cartState)
 * */
/**
 * Event to fire/listen to after updating cart
 * @param {object} e
 * @param {object|undefined} cartState
 * theme:onCartUpdate (e, cartState)
 * */

Shopify.theme.state = {};

// Apply a specific class to the html element for browser support of cookies.
if (window.navigator.cookieEnabled) {
	document.documentElement.className = document.documentElement.className.replace(
		'supports-no-cookies',
		'supports-cookies',
	);
}

function getStickyHeaderHeight() {
	return $('header.is-sticky').outerHeight() || 0;
}

function scrollToSelector(targetSelector, speed = 300, offset = 0) {
	if (targetSelector && targetSelector !== '#' && $(targetSelector).length) {
		scrollToElement($(targetSelector), speed, offset);
	}
}

function scrollToElement($targetElement, speed = 300, offset = 0) {
	if ($targetElement.length) {
		$('html,body').animate(
			{
				scrollTop: $targetElement.offset().top + +offset - getStickyHeaderHeight(),
			},
			+speed,
		);
	}
}

function throttle(callback, limit) {
	var wait = false;
	return function (...args) {
		if (!wait) {
			callback(...args);
			wait = true;
			setTimeout(function () {
				wait = false;
			}, limit);
		}
	};
}

function debounce(callback, timeout = 300) {
	let timer;
	return (...args) => {
		clearTimeout(timer);
		timer = setTimeout(() => {
			callback.apply(this, args);
		}, timeout);
	};
}

function checkElementVisibility(elm, threshold, mode) {
	threshold = threshold || 0;
	mode = mode || 'visible';

	if (elm instanceof jQuery) elm = elm.get(0);

	const rect = elm.getBoundingClientRect();
	const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
	const above = rect.bottom - threshold < 0;
	const below = rect.top - viewHeight + threshold >= 0;

	return mode === 'above' ? above : mode === 'below' ? below : !above && !below;
}

/**
 * Get the first scrollable parent
 * @return {jQuery}
 * */
jQuery.fn.scrollParent = function () {
	var position = this.css('position'),
		excludeStaticParent = position === 'absolute',
		scrollParent = this.parents()
			.filter(function () {
				var parent = $(this);
				if (excludeStaticParent && parent.css('position') === 'static') {
					return false;
				}
				return /(auto|scroll)/.test(
					parent.css('overflow') + parent.css('overflow-y') + parent.css('overflow-x'),
				);
			})
			.eq(0);

	return position === 'fixed' || !scrollParent.length
		? $(this[0].ownerDocument || document)
		: scrollParent;
};

Shopify.theme.getSectionData = function (sectionContainer) {
	const dataElement = sectionContainer.querySelector('[data-section-data]');
	if (!dataElement) return {};

	try {
		return JSON.parse(dataElement.innerHTML);
	} catch (error) {
		console.warn('Sections: invalid section data found. '.concat(error.message));
		return {};
	}
};

Shopify.theme.formatMoney = function (cents, format = window.theme.money.format) {
	if (typeof cents === 'string') {
		cents = cents.replace('.', '');
	}
	let value = '';
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	const formatString = format;

	function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
		if (isNaN(number) || number == null) {
			return 0;
		}

		number = (number / 100.0).toFixed(precision);

		const parts = number.split('.');
		const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
		const centsAmount = parts[1] ? decimal + parts[1] : '';

		return dollarsAmount + centsAmount;
	}

	switch (formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2);
			break;
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0);
			break;
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',');
			break;
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',');
			break;
	}

	return formatString.replace(placeholderRegex, value);
};

const drawerExtension = {
	openDrawer: function () {
		if (Shopify.theme.sections.getInstanceById('header-search').isOpen()) {
			$('body').trigger('theme:closeDrawer', ['all']);
			$('body').one('theme:searchTransitionEnd', () => {
				this.$drawerToggleElement.addClass(this.drawerOpenClass);
				$('html').addClass('is-drawer-open');
				$('body').trigger('theme:onDrawerOpen', [this.type]);
			});
		} else {
			$('body').trigger('theme:closeDrawer', ['all']);
			this.$drawerToggleElement.addClass(this.drawerOpenClass);
			$('html').addClass('is-drawer-open');
			$('body').trigger('theme:onDrawerOpen', [this.type]);
		}
	},
	closeDrawer: function () {
		this.$drawerToggleElement.removeClass(this.drawerOpenClass);
		$('html').removeClass('is-drawer-open');
		$('body').trigger('theme:onDrawerClose', [this.type]);
	},
	init: function () {
		this.$drawerToggleElement = $(this.container);
		this.drawerOpenClass = 'is-open';
		$('body').on('theme:openDrawer', (e, drawer) => {
			if (drawer === this.type) {
				this.openDrawer();
			}
		});
		$('body').on('theme:closeDrawer', (e, drawer) => {
			if (drawer === this.type || drawer === 'all') {
				this.closeDrawer();
			}
		});
		$(this.container).on('click', '.js-close-drawer', (e) => {
			e.preventDefault();
			this.closeDrawer();
		});
		this.$drawerToggleElement.on('transitionend webkitTransitionEnd oTransitionEnd', function () {
			$('body').trigger('theme:drawerTransitionEnd');
		});
	},
	onUnload: function () {
		this.closeDrawer();
	},
	onSelect: function () {
		this.openDrawer();
	},
	onDeselect: function () {
		this.closeDrawer();
	},
	onBlockSelect: function () {
		this.openDrawer();
	},
	onBlockDeselect: function () {
		this.closeDrawer();
	},
};

Shopify.theme.sections.register('header', {
	initMenuButton: function () {
		const menuButtonSelector = '.js-toggle-menu';
		const menuButtonOpenClass = 'is-active';

		$('body').on('theme:onDrawerOpen', (e, drawer) => {
			if (drawer === 'menu-drawer') {
				$(menuButtonSelector).addClass(menuButtonOpenClass);
			}
		});
		$('body').on('theme:onDrawerClose', (e, drawer) => {
			if (drawer === 'menu-drawer') {
				$(menuButtonSelector).removeClass(menuButtonOpenClass);
			}
		});

		$(menuButtonSelector).on('click', function (e) {
			e.preventDefault();
			if ($(this).hasClass(menuButtonOpenClass)) {
				$('body').trigger('theme:closeDrawer', ['menu-drawer']);
			} else {
				$('body').trigger('theme:openDrawer', ['menu-drawer']);
			}
		});
	},
	initLocalizationButton: function () {
		const buttonSelector = '.js-toggle-localization';
		const buttonOpenClass = 'is-active';

		$('body').on('theme:onDrawerOpen', (e, drawer) => {
			if (drawer === 'localization-drawer') {
				$(buttonSelector).addClass(buttonOpenClass);
			}
		});
		$('body').on('theme:onDrawerClose', (e, drawer) => {
			if (drawer === 'localization-drawer') {
				$(buttonSelector).removeClass(buttonOpenClass);
			}
		});

		$(buttonSelector).on('click', function (e) {
			e.preventDefault();
			if ($(this).hasClass(buttonOpenClass)) {
				$('body').trigger('theme:closeDrawer', ['localization-drawer']);
			} else {
				$('body').trigger('theme:openDrawer', ['localization-drawer']);
			}
		});
	},
	initSearchButton: function () {
		const searchButtonSelector = '.js-toggle-search';
		const searchButtonOpenClass = 'is-active';

		$('body').on('theme:onHeaderSearchOpen', () => {
			$(searchButtonSelector).addClass(searchButtonOpenClass);
		});
		$('body').on('theme:onHeaderSearchClose', () => {
			$(searchButtonSelector).removeClass(searchButtonOpenClass);
		});

		$(searchButtonSelector).on('click', function (e) {
			e.preventDefault();
			if ($(this).hasClass(searchButtonOpenClass)) {
				// $('body').trigger('theme:closeHeaderSearch');
				const evt = new CustomEvent('theme:closeHeaderSearch');
				document.body.dispatchEvent(evt);
			} else {
				// $('body').trigger('theme:openHeaderSearch');
				const evt = new CustomEvent('theme:openHeaderSearch');
				document.body.dispatchEvent(evt);
			}
		});
	},
	initWishlistLink: function () {
		window.WishlistKing.observe(
			{
				selector: `[data-section-id="${this.id}"] .js-wishlist-link`,
			},
			(target) => {
				target.append(window.WishlistKing.createComponent('wishlist-link'));
			},
		);
	},
	initCartButton: function () {
		$('body').on(
			'theme:onCartItemAdd theme:onCartItemRemove theme:onCartItemUpdate',
			async (e, item, cartState) => {
				if (!cartState) cartState = await Shopify.theme.cart.getState();

				const $cartCount = $(this.container).find('.js-cart-item-count');
				$cartCount.text(cartState.item_count);
				if (cartState.item_count > 0) {
					$cartCount.removeClass('hide');
				} else {
					$cartCount.addClass('hide');
				}
			},
		);

		$(this.container).on('click', this.selectors.cartButton, (e) => {
			if (window.theme.request.page_type === 'cart') return;
			const popupCartInstance = Shopify.theme.sections.getInstanceById('popup-cart');
			if (popupCartInstance !== undefined) {
				e.preventDefault();
				popupCartInstance.toggleCart();
			}
		});

		$('body').on('theme:onPopupCartOpen', () => {
			$(this.container).find(this.selectors.cartButton).addClass('is-active');
		});
		$('body').on('theme:onPopupCartClose', () => {
			if (window.theme.request.page_type === 'cart') return;
			$(this.container).find(this.selectors.cartButton).removeClass('is-active');
		});
	},
	initCartNotice: function () {
		$('body').on('theme:onCartItemAdd theme:onCartItemRemove theme:onCartItemUpdate', () => {
			$(this.container).find('.js-cart-notice').slideToggle(200);
			setTimeout(() => {
				$(this.container).find('.js-cart-notice').slideToggle(200);
			}, 5000);
		});
	},
	onLoad: function () {
		this.selectors = {
			cartButton: '.js-cart-button',
		};

		this.initMenuButton();
		this.initLocalizationButton();
		this.initSearchButton();
		this.initCartButton();
		// this.initCartNotice();

		// if (window.WishlistKing) {
		// 	this.initWishlistLink();
		// } else {
		// 	$('body').on('app:wishlistKing:ready', (e) => {
		// 		this.initWishlistLink();
		// 	});
		// }
	},
});

Shopify.theme.sections.register('popup-cart', {
	reloadCart: async function () {
		const url = window.location.pathname + '?section_id=' + this.id;
		await $.ajax(url, {
			method: 'GET',
			dataType: 'html',
			success: (data) => {
				const newCart = $(data).find(this.selectors.cartContent).html();
				$(this.selectors.cartContent).html(newCart);
			},
		});
	},
	openCart: function () {
		$(this.container).find(this.selectors.cart).addClass(this.selectors.cartOpenClass);
		$(this.container).find(this.selectors.cartContainer).slideDown(200);
		$('body').trigger('theme:onPopupCartOpen');
	},
	closeCart: function () {
		$(this.container).find(this.selectors.cart).removeClass(this.selectors.cartOpenClass);
		$(this.container).find(this.selectors.cartContainer).slideUp(200);
		$('body').trigger('theme:onPopupCartClose');
	},
	toggleCart: function () {
		if (this.isCartOpen()) {
			this.closeCart();
		} else {
			this.openCart();
		}
	},
	isCartOpen: function () {
		return $(this.container).find(this.selectors.cart).hasClass(this.selectors.cartOpenClass);
	},
	setupListeners: function () {
		$('body').on(
			'theme:onCartItemAdd theme:onCartItemRemove theme:onCartItemUpdate',
			(e, item, cartState) => {
				this.reloadCart().then(() => {
					$('body').trigger('theme:onCartUpdate', [cartState]);
					// this.openCart();
					
				});
			},
		);
		$('body').on(
			'theme:onCartItemAdd',
			(e, item, cartState) => {
				this.reloadCart().then(() => {
					$('body').trigger('theme:onCartUpdate', [cartState]);
					this.openCart();
		
					setTimeout(() => {
						this.closeCart();
					}, 5000);
				});
			},
		);

		$('body').on('click', (e) => {
			if (e.target.closest('.c-header__cart-button') || e.target.closest('.c-popup-cart__outer') || e.target.closest('.o-product-option-1__dropdown')) return;
			this.closeCart()
		});
	},
	onLoad: function () {
		this.extend(cartItem1Extension);

		this.selectors = {
			cart: '.js-popup-cart',
			cartContainer: '.js-popup-cart__container', // this container toggles and contains the open class
			cartContent: '.js-popup-cart__content',
			cartOpenClass: 'is-open',
			closeButton: '.js-popup-cart__close-button',
		};

		this.setupListeners();
	},
});

Shopify.theme.sections.register('header-navigation', {
	hideDropdownMenu: function ($item, $menu) {
		$menu.removeClass(this.menuActiveClass);
		$item.removeClass(this.activeItemClass);
	},
	showDropdownMenu: function ($item, $menu) {
		$menu.addClass(this.menuActiveClass);
		$item.addClass(this.activeItemClass);
	},
	hideAllDropdownMenus: function () {
		this.hideDropdownMenu($(this.itemSelector), $(this.menuSelector));
	},
	initDropdownMenu: function () {
		const $dropdownMenuItems = $(this.container).find(this.itemSelector);

		$dropdownMenuItems.each((i, item) => {
			const $item = $(item);
			const $menu = $item.find(this.menuSelector);

			$item.hover(
				() => {
					setTimeout(() => {
						if ($item.is(':hover')) {
							this.showDropdownMenu($item, $menu);
						}
					}, 150);
				},
				() => {
					setTimeout(() => {
						if (!$item.is(':hover')) {
							this.hideDropdownMenu($item, $menu);
						}
					}, 150);
				},
			);

			$item.on('touchend', (e) => {
				e.preventDefault();
				if ($item.hasClass(this.activeItemClass)) {
					this.hideDropdownMenu($item, $menu);
				} else {
					this.hideAllDropdownMenus();
					this.showDropdownMenu($item, $menu);
				}
			});
		});
	},
	onLoad: function () {
		this.activeItemClass = 'is-menu-open';
		this.menuActiveClass = 'is-active';
		this.itemSelector = '.js-dropdown-menu-item';
		this.menuSelector = '.js-dropdown-menu';
		this.initDropdownMenu();
	},
});

Shopify.theme.sections.register('announcement-bar', {
	initSlider: function () {
		const $sliderNode = $(this.container).find('.js-slider');
		this.swiper = new Swiper($sliderNode.get(0), {
			slidesPerView: 'auto',
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			a11y: true,
			loop: true,
			keyboard: true,
			grabCursor: true,
			speed: 750,
			breakpoints: {
				600: {
					speed: 1250,
				},
			},
		});
	},
	onLoad: function () {
		this.initSlider();
	},
});

Shopify.theme.sections.register('menu-drawer', {
	switchNavigationLevel: function (level) {
		$(this.navLevelsWrapSelector).attr(this.navLevelsWrapDataKey, level);
		$(this.navLevelSelector).removeClass(this.navActiveLevelClass);
		$(this.navLevelSelector)
			.filter(`[${this.navLevelDataKey}="${level}"]`)
			.addClass(this.navActiveLevelClass);
	},
	switchNavigationSubmenu: function (submenu) {
		const $targetSubmenuElement = $(this.navSubmenuSelector).filter(
			`[${this.navSubmenuDataKey}="${submenu}"]`,
		);
		const targetLevel = $targetSubmenuElement
			.parents(this.navLevelSelector)
			.attr(this.navLevelDataKey);
		const $targetLevelElement = $(this.navLevelSelector).filter(
			`[${this.navLevelDataKey}="${targetLevel}"]`,
		);

		$targetLevelElement.find(this.navSubmenuSelector).removeClass(this.navActiveSubmenuClass);
		$targetSubmenuElement.addClass(this.navActiveSubmenuClass);
		this.switchNavigationLevel(targetLevel);
	},
	initNavigationLevels: function () {
		const _this = this;
		$('.js-toggle-level').on('click', function (e) {
			e.preventDefault();
			const $button = $(this);
			const targetLevel = $button.attr(_this.navTargetLevelDataKey);
			_this.switchNavigationLevel(targetLevel);
		});
		$('.js-toggle-submenu').on('click', function (e) {
			e.preventDefault();
			const $button = $(this);
			const targetSubmenu = $button.attr(_this.navTargetSubmenuDataKey);
			_this.switchNavigationSubmenu(targetSubmenu);
		});
	},
	onLoad: function () {
		this.extend(drawerExtension);

		this.navLevelsWrapSelector = '.js-levels-wrap';
		this.navLevelSelector = '.js-level';
		this.navSubmenuSelector = '.js-level-submenu';
		this.navActiveLevelClass = 'is-active';
		this.navActiveSubmenuClass = 'is-active';
		this.navTargetLevelDataKey = 'data-target-level';
		this.navLevelDataKey = 'data-level';
		this.navTargetSubmenuDataKey = 'data-target-submenu';
		this.navSubmenuDataKey = 'data-submenu-for';
		this.navLevelsWrapDataKey = 'data-current-level';
		this.initNavigationLevels();
	},
});

Shopify.theme.sections.register('header-search', {
	openSearch: function () {
		$('body').trigger('theme:closeDrawer', ['all']);
		this.$searchToggleElement.addClass(this.searchOpenClass);
		// $('body').trigger('theme:onHeaderSearchOpen');
		const evt = new CustomEvent('theme:onHeaderSearchOpen');
		document.body.dispatchEvent(evt);
	},
	closeSearch: function () {
		this.$searchToggleElement.removeClass(this.searchOpenClass);
		// $('body').trigger('theme:onHeaderSearchClose');
		const evt = new CustomEvent('theme:onHeaderSearchClose');
		document.body.dispatchEvent(evt);
	},
	isOpen: function () {
		return this.$searchToggleElement.hasClass(this.searchOpenClass);
	},
	initSearchToggle: function () {
		$('body').on('theme:openHeaderSearch', () => {
			this.openSearch();
		});
		$('body').on('theme:closeHeaderSearch theme:closeAllDrawers', () => {
			this.closeSearch();
		});
		$('body').on('theme:closeDrawer', (e, drawer) => {
			if (drawer === 'all') {
				this.closeSearch();
			}
		});
		this.$searchToggleElement.on('transitionend webkitTransitionEnd oTransitionEnd', () => {
			$('body').trigger('theme:searchTransitionEnd');
			if (!Shopify.designMode && this.isOpen()) {
				this.$searchInputElement.focus();
			}
		});
	},
	onLoad: function () {
		this.$searchToggleElement = $(this.container).find('.js-search-toggle');
		this.$searchInputElement = $(this.container).find('.js-search-input');
		this.searchOpenClass = 'is-open';

		if (this.$searchToggleElement.hasClass('is-toggleable')) {
			this.initSearchToggle();
		}
	},
	onUnload: function () {
		this.closeSearch();
	},
	onSelect: function () {
		this.openSearch();
	},
	onDeselect: function () {
		this.closeSearch();
	},
	onBlockSelect: function () {
		this.openSearch();
	},
	onBlockDeselect: function () {
		this.closeSearch();
	},
});

const navAccordionExtension = {
	init: function () {
		const accordionSelector = '.js-accordion';
		const triggerSelector = '.js-open-accordion';
		const contentSelector = '.js-accordion-content';
		const accordionOpenClass = 'is-open';
		const linkDataKey = 'data-link';

		const toggleAccordion = ($accordionElement, slideDuration = 358) => {
			const $accordionContentElement = $accordionElement.find(contentSelector);

			$accordionElement.toggleClass(accordionOpenClass);
			$accordionContentElement.slideToggle(slideDuration);
		};

		$(this.container).on('click', triggerSelector, function (e) {
			toggleAccordion($(this).parents(accordionSelector));
		});

		// open item if the url contains hash of its ID
		const _this = this;
		$(window).on('load', function () {
			if (window.location.hash.length) {
				const targetSelector = decodeURI(window.location.hash);
				const $targetAccordion = $(_this.container).find(accordionSelector).filter(targetSelector);
				if ($targetAccordion.length) {
					toggleAccordion($targetAccordion.first());
					scrollToElement($targetAccordion);
				}
			}
		});

		// open item if a faqItem opens
		$(this).on('section:faqItemExternalOpen', (e, $faqItem) => {
			if (!$faqItem.length) return;
			const $targetAccordion = $faqItem.parents(accordionSelector);
			if ($targetAccordion.length) toggleAccordion($targetAccordion);
		});

		// get admin link
		if (Shopify.designMode) {
			$(_this.container).on('contextmenu', triggerSelector, function (e) {
				e.preventDefault();
				e.stopPropagation();
				const $targetAccordion = $(this).parents(accordionSelector);
				const linkURL = $targetAccordion.attr(linkDataKey);
				if (linkURL.length) {
					navigator.clipboard.writeText(linkURL).then(() => {
						alert('Link copied');
					});
				}
			});
		}
	},
};

Shopify.theme.sections.register('footer-main', {
	handleGDPRLink: function () {
		$(this.container).on('click', '.js-footer-main__gdpr-link', (e) => {
			e.preventDefault();
			$('body').trigger('theme:openGDPR');
		});
	},
	onLoad: function () {
		this.handleGDPRLink();
	},
});

Shopify.theme.sections.register('footer-info', {
	handleGDPRLink: function () {
		$(this.container).on('click', '.js-footer-info__gdpr-link', (e) => {
			e.preventDefault();
			$('body').trigger('theme:openGDPR');
		});
	},
	onLoad: function () {
		this.extend(navAccordionExtension);
		this.handleGDPRLink();
	},
});

Shopify.theme.sections.register('newsletter', {
	sendForm: function () {
		const form = this.$formElement;
		const formId = form.attr('id');
		$.ajax({
			url: form.attr('action'),
			method: 'POST',
			data: form.serialize(),
			beforeSend: function () {
				form.find('[type="submit"]').attr('disabled', 'disabled');
			},
			error: function (responseError) {
				console.error(responseError);
			},
			success: function (data, textStatus) {
				$('body').trigger('theme:openDrawer', ['newsletter-success']);
			},
			complete: function () {
				form.find('[type="submit"]').removeAttr('disabled');
				form.trigger('reset');
			},
		});
	},
	selectGenderBySubmit: function ($submitButtonElement) {
		const gender = $submitButtonElement.attr('data-gender');
		this.$genderInputElement.val(gender);
	},
	initForm: function () {
		this.$formElement.on('submit', (e) => {
			e.preventDefault();
			e.stopImmediatePropagation();
			e.stopPropagation();
			this.selectGenderBySubmit($(e.originalEvent.submitter));
			this.sendForm();
		});
	},
	onLoad: function () {
		this.$formElement = $(this.container).find('.js-form');
		this.$genderInputElement = $(this.container).find('input[name="contact[note][Gender]"]');
		this.initForm();
	},
});

Shopify.theme.sections.register('newsletter-2', {
	sendForm: function () {
		const form = this.$formElement;
		const formId = form.attr('id');
		$.ajax({
			url: form.attr('action'),
			method: 'POST',
			data: form.serialize(),
			beforeSend: function () {
				form.find('[type="submit"]').attr('disabled', 'disabled');
			},
			error: function (responseError) {
				console.error(responseError);
				if (responseError.status === 429) {
					form.off('.newsletter-2');
					form.submit();
				}
			},
			success: function (data, textStatus) {
				$('body').trigger('theme:openDrawer', ['newsletter-success']);
			},
			complete: function () {
				form.find('[type="submit"]').removeAttr('disabled');
				form.trigger('reset');
			},
		});
	},
	selectGenderBySubmit: function ($submitButtonElement) {
		const gender = $submitButtonElement.attr('data-gender');
		this.$genderInputElement.val(gender);
	},
	toggleGenderButtons: function () {
		$(this.genderButtonsSelector).slideToggle(300);
		$(this.genderButtonsTriggerSelector).toggleClass('is-active');
	},
	initForm: function () {
		this.$formElement.on('submit.newsletter-2', (e) => {
			e.preventDefault();
			e.stopImmediatePropagation();
			e.stopPropagation();
			this.selectGenderBySubmit($(e.originalEvent.submitter));
			this.sendForm();
		});
	},
	onLoad: function () {
		this.$formElement = $(this.container).find('.js-form');
		this.$genderInputElement = $(this.container).find('input[name="contact[note][Gender]"]');
		this.genderButtonsSelector = '.js-gender-buttons';
		this.genderButtonsTriggerSelector = '.js-gender-buttons-trigger';
		this.initForm();

		$(this.container).on('click', this.genderButtonsTriggerSelector, (e) => {
			this.toggleGenderButtons();
		});
	},
});

Shopify.theme.sections.register('newsletter-success', {
	onLoad: function () {
		this.extend(drawerExtension);
		$('.js-close-drawer').on('click', (e) => {
			e.preventDefault();
			$('body').trigger('theme:closeDrawer', ['newsletter-success']);
		});
	},
});

Shopify.theme.sections.register('slider-1', {
	initSlider: function () {
		this.$sliderElement = $(this.container).find('.js-slider');
		const swiper = new Swiper(this.$sliderElement.get(0), {
			slidesPerView: 'auto',
			spaceBetween: 20,
			cssMode: true,
			breakpoints: {
				811: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
			},
			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
			},
			mousewheel: {
				forceToAxis: true,
			},
		});
	},
	onLoad: function () {
		this.initSlider();
	},
});

Shopify.theme.sections.register('slider-2', {
	initSlider: function () {
		const $sliderNode = $(this.container).find('.js-slider');
		this.swiper = new Swiper($sliderNode.get(0), {
			slidesPerView: 'auto',
			// spaceBetween: 20,
			cssMode: true,
			breakpoints: {},
			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
			},
			mousewheel: {
				forceToAxis: true,
			},
		});
	},
	onLoad: function () {
		this.initSlider();
	},
	onUnload: function () {
		this.swiper.destroy();
	},
});

Shopify.theme.sections.register('product-slider-1', {
	initSlider: function () {
		const $sliderNode = $(this.container).find('.js-slider');
		this.swiper = new Swiper($sliderNode.get(0), {
			slidesPerView: 'auto',
			cssMode: true,
			navigation: {
				prevEl: $(this.container).find('.js-slider-prev').get(0),
				nextEl: $(this.container).find('.js-slider-next').get(0),
				disabledClass: 'is-disabled',
			},
			breakpoints: {},
			scrollbar: {
				el: $(this.container).find('.js-slider-scrollbar').get(0),
				draggable: true,
			},
			mousewheel: {
				forceToAxis: true,
			},
		});
	},
	onLoad: function () {
		this.initSlider();
	},
	onUnload: function () {
		this.swiper.destroy();
	},
});

Shopify.theme.sections.register('product-slider-2', {
	initSlider: function () {
		const $sliderNode = $(this.container).find('.js-slider');
		this.swiper = new Swiper($sliderNode.get(0), {
			slidesPerView: 'auto',
			cssMode: true,
			navigation: {
				prevEl: $(this.container).find('.js-slider-prev').get(0),
				nextEl: $(this.container).find('.js-slider-next').get(0),
				disabledClass: 'is-disabled',
			},
			breakpoints: {},
			scrollbar: {
				el: $(this.container).find('.js-slider-scrollbar').get(0),
				draggable: true,
			},
			mousewheel: {
				forceToAxis: true,
			},
		});
	},
	onLoad: function () {
		this.initSlider();
	},
	onUnload: function () {
		this.swiper.destroy();
	},
});

Shopify.theme.sections.register('product-slider-3', {
	initSlider: function () {
		const $sliderNode = $(this.container).find('.js-slider');
		this.swiper = new Swiper($sliderNode.get(0), {
			slidesPerView: 'auto',
			cssMode: true,
			navigation: {
				prevEl: $(this.container).find('.js-slider-prev').get(0),
				nextEl: $(this.container).find('.js-slider-next').get(0),
				disabledClass: 'is-disabled',
			},
			breakpoints: {
				320: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 'auto',
				},
			},
			scrollbar: {
				el: $(this.container).find('.js-slider-scrollbar').get(0),
				draggable: true,
			},
			mousewheel: {
				forceToAxis: true,
			},
		});
	},
	onLoad: function () {
		this.initSlider();
	},
	onUnload: function () {
		this.swiper.destroy();
	},
});
Shopify.theme.sections.register('collection-slider', {
	initSlider: function() {
		const $sliderNode = $(this.container).find('.js-slider');
		this.swiper = new Swiper($sliderNode.get(0), {
			slidesPerView: 'auto',
			cssMode: true,
			navigation: {
				prevEl: $(this.container).find('.js-slider-prev').get(0),
				nextEl: $(this.container).find('.js-slider-next').get(0),
				disabledClass: 'is-disabled'
			},
			breakpoints: {},
			scrollbar: {
				el: $(this.container).find('.js-slider-scrollbar').get(0),
				draggable: true
			},
			mousewheel: {
				forceToAxis: true
			}
		});
	},
	onLoad: function() {
		this.initSlider();
	},
	onUnload: function() {
		this.swiper.destroy();
	}
});

Shopify.theme.sections.register('banner-12', {
	initSlider: function () {
		const $sliderNode = $(this.container).find('.js-slider');
		this.swiper = new Swiper($sliderNode.get(0), {
			slidesPerView: localStorage.getItem('banner-12') ? +localStorage.getItem('banner-12') : 3,
			spaceBetween: 28.8,
			breakpoints: {
				320: {
					slidesPerView: 1,
				},
				811: {
					slidesPerView: localStorage.getItem('banner-12') ? +localStorage.getItem('banner-12') : 3,
					navigation: {
						nextEl: $(this.container).find('.c-banner-12-next').get(0),
						prevEl: $(this.container).find('.c-banner-12-prev').get(0)
					}
				},
			},
			scrollbar: {
				el: $(this.container).find('.js-slider-scrollbar').get(0),
				draggable: true,
			},
			mousewheel: {
				forceToAxis: true,
			},
		});
	},
	onLoad: function () {
		this.initSlider();
	},
	onUnload: function () {
		this.swiper.destroy();
	},
});

const scrollButtonExtension = {
	init: function () {
		$('body').on('click', '.js-scroll-button', function (e) {
			e.preventDefault();
			const targetSelector = $(this).attr('href');
			const speed = $(this).attr('data-scroll-speed') || 300;
			const offset = $(this).attr('data-scroll-offset') || 0;
			scrollToSelector(targetSelector, speed, offset);
		});
	},
};

Shopify.theme.sections.register('button-3', {
	onLoad: function () {
		this.extend(scrollButtonExtension);
	},
});

const faqItemExtension = {
	toggleFaqItem: function ($curFaqItemNode) {
		const $curFaqAnswerNode = $curFaqItemNode.find(this.faqAnswerSelector);

		if ($curFaqItemNode.hasClass(this.faqItemOpenClass)) {
			$curFaqItemNode.removeClass(this.faqItemOpenClass);
			$curFaqAnswerNode.slideToggle(500);
		} else {
			this.$faqItemNode.removeClass(this.faqItemOpenClass);
			$curFaqItemNode.addClass(this.faqItemOpenClass);
			$curFaqAnswerNode.slideToggle(500);
		}
	},
	initFaqItems: function () {
		this.$faqItemNode.each((index, element) => {
			const $curFaqItemNode = $(element);
			const $curFaqQuestionNode = $curFaqItemNode.find(this.faqQuestionSelector);
			const _this = this;

			$curFaqQuestionNode.on('click', function (e) {
				e.preventDefault();
				_this.toggleFaqItem($curFaqItemNode);
			});
		});
	},
	init: function () {
		this.faqItemSelector = '.js-faq-item';
		this.$faqItemNode = $(this.container).find(this.faqItemSelector);
		this.faqQuestionSelector = '.js-faq-item__question';
		this.faqAnswerSelector = '.js-faq-item__answer';
		this.faqItemOpenClass = 'is-open';
		this.linkDataKey = 'data-link';

		const _this = this;

		// open an item if the url contains hash of its ID
		$(window).on('load', function () {
			if (window.location.hash.length) {
				const targetSelector = decodeURI(window.location.hash);
				const $targetFaqItem = _this.$faqItemNode.filter(targetSelector);
				if ($targetFaqItem.length) {
					_this.toggleFaqItem($targetFaqItem.first());
					$(_this).trigger('section:faqItemExternalOpen', [$targetFaqItem]);
					scrollToElement($targetFaqItem);
				}
			}
		});

		// get admin link
		if (Shopify.designMode) {
			$(_this.container).on('contextmenu', this.faqQuestionSelector, function (e) {
				e.preventDefault();
				e.stopPropagation();
				const $targetAccordion = $(this).parents(_this.faqItemSelector);
				const linkURL = $targetAccordion.attr(_this.linkDataKey);
				if (linkURL.length) {
					navigator.clipboard.writeText(linkURL).then(() => {
						alert('Link copied');
					});
				}
			});
		}
	},
};

Shopify.theme.sections.register('faq-1', {
	toggleCategory: function (category) {
		this.$categoryButtonNode.removeClass(this.categoryButtonActiveClass);
		this.$categoryButtonNode
			.filter(`[${this.categoryButtonDataKey}="${category}"]`)
			.addClass(this.categoryButtonActiveClass);
		this.$categoryContentNode.removeClass(this.categoryContentActiveClass).hide(500);
		this.$categoryContentNode
			.filter(`[${this.categoryContentDataKey}="${category}"]`)
			.addClass(this.categoryContentActiveClass)
			.show(500);
	},
	initCategories: function () {
		const _this = this;
		this.$categoryButtonNode.on('click', function (e) {
			e.preventDefault();
			const targetCategory = $(this).attr(_this.categoryButtonDataKey);
			_this.toggleCategory(targetCategory);
		});
	},
	toggleFaqItem: function ($curFaqItemNode) {
		const $curFaqAnswerNode = $curFaqItemNode.find(this.faqAnswerSelector);

		if ($curFaqItemNode.hasClass(this.faqItemOpenClass)) {
			$curFaqItemNode.removeClass(this.faqItemOpenClass);
			$curFaqAnswerNode.slideToggle(500);
		} else {
			this.$faqItemNode.removeClass(this.faqItemOpenClass);
			$curFaqItemNode.addClass(this.faqItemOpenClass);
			$curFaqAnswerNode.slideToggle(500);
		}
	},
	initFaqItems: function () {
		this.$faqItemNode.each((index, element) => {
			const $curFaqItemNode = $(element);
			const $curFaqQuestionNode = $curFaqItemNode.find(this.faqQuestionSelector);
			const _this = this;

			$curFaqQuestionNode.on('click', function (e) {
				e.preventDefault();
				_this.toggleFaqItem($curFaqItemNode);
			});
		});
	},
	onLoad: function () {
		this.$categoryButtonNode = $(this.container).find('.js-category-button');
		this.categoryButtonActiveClass = 'is-active';
		this.categoryButtonDataKey = 'data-target-category';
		this.$categoryContentNode = $(this.container).find('.js-category-content');
		this.categoryContentActiveClass = 'is-active';
		this.categoryContentDataKey = 'data-category-content';
		this.initCategories();

		this.$faqItemNode = $(this.container).find('.js-faq-item');
		this.faqQuestionSelector = '.js-faq-item__question';
		this.faqAnswerSelector = '.js-faq-item__answer';
		this.faqItemOpenClass = 'is-open';
		this.initFaqItems();

		this.extend(navAccordionExtension);
	},
});

Shopify.theme.sections.register('faq-2', {
	onLoad: function () {
		this.extend(faqItemExtension);
		this.initFaqItems();

		this.extend(navAccordionExtension);
	},
});

Shopify.theme.sections.register('collection-boost-1', {
	_getFilterSection: function () {
		return window.Shopify.theme.sections.getInstanceById('filter-boost-1');
	},
	handleControlsStickyState: function () {
		this.$stickyControlsNode = $(this.container).find('.js-sticky-controls');

		$(window).on('scroll resize', () => {
			const stickyControlsOffsetTop =
				this.$stickyControlsNode.offset().top - parseInt(this.$stickyControlsNode.css('top'), 10);
			if ($(window).scrollTop() === stickyControlsOffsetTop) {
				this.$stickyControlsNode.addClass('is-sticky');
			} else {
				this.$stickyControlsNode.removeClass('is-sticky');
			}
		});
	},
	initControlButtons: function () {
		$(this.container)
			.find('.js-open-filter')
			.on('click', (e) => {
				e.preventDefault();
				$('body').trigger('theme:openDrawer', ['filter-boost-1']);
			});
		$(this.container)
			.find('.js-open-sort')
			.on('click', (e) => {
				e.preventDefault();
				$('body').trigger('theme:openDrawer', ['sort-boost-1']);
			});
	},
	updateFiltersRow: function (boostApiData, selectedOptions) {
		if (!boostApiData || !selectedOptions) return;

		// build an array of options
		let options = [];
		selectedOptions.forEach((option) => {
			const existedOption = options.find((_option) => _option.id === option.id);
			if (existedOption) {
				existedOption.count_total++;
			} else {
				const optionApi = boostApiData.filter.options.find(
					(_option) => _option.filterOptionId === option.id.replace('[]', ''),
				);
				optionApi &&
					options.push({
						id: option.id,
						label: optionApi.label,
						count_total: 1,
					});
			}
		});

		// render options
		{
			let $optionTemplate = $(this.container).find('.t-filter-option');
			let templateHtml = '';
			options.forEach((option) => {
				templateHtml += $optionTemplate
					.html()
					.replace(/{{id}}/g, option.id)
					.replace(/{{label}}/g, `${option.label} (${option.count_total})`);
			});
			$(this.container).find('.js-collection__filters-row').html(templateHtml);
		}
	},
	initFiltersRow: function () {
		// get options if a filter instance is already there
		if (this.filterSection) {
			this.updateFiltersRow(
				this.filterSection.boostApiData,
				this.filterSection.filter.selectedOptions,
			);
		}

		// get options when a filter has been updated
		$('body').on('theme:collectionFilterUpdated', (e, boostApiData, selectedOptions) => {
			this.updateFiltersRow(boostApiData, selectedOptions);
		});

		// deselect a filter option by removing it from the filters row
		const removeFilter = (e) => {
			const optionId = e.currentTarget.dataset.option;
			if (!this.filterSection) this.filterSection = this._getFilterSection();

			// immediately remove it from the filters row
			$(e.currentTarget).parents('.js-collection__filter-option').remove();

			// deselect it in the filter section, it'll trigger an update and re-render
			this.filterSection.removeFilterOption(optionId);
		};
		$(this.container).on(
			'click',
			'.js-collection__remove-filter',
			throttle((e) => removeFilter(e), 1000),
		);
	},
	onLoad: function () {
		this.filterSection = this._getFilterSection();
		this.handleControlsStickyState();
		this.initControlButtons();
		this.initFiltersRow();
	},
});

const filterItem1Extension = {
	filterOption: {
		getOption: function (optionId) {
			return this.$container.find(
				`${this.selector.option}[${this.dataKey.optionId}="${optionId}"]`,
			);
		},
		getOptionValue: function (optionId, optionValue) {
			return this.$container
				.find(`${this.selector.option}[${this.dataKey.optionId}="${optionId}"]`)
				.find(`${this.selector.value}[${this.dataKey.optionValue}="${optionValue}"]`);
		},
		isOptionSelected: function (optionId) {
			const $option = this.getOption(optionId);
			return !!$option.find(this.selector.inputCheckbox).filter(':checked').length;
		},
		toggleOptionValue: function (optionId, optionValue) {
			const $value = this.getOptionValue(optionId, optionValue);
			const $checkbox = $value.find(this.selector.inputCheckbox);
			const prevState = $checkbox.prop('checked');
			$checkbox.prop('checked', !prevState);
		},
		openFilterItemAccordion: function ($item, isInstant = false) {
			const optionId = $item.attr(this.dataKey.optionId);

			// close other filter items
			this.$container.find(this.selector.option).removeClass(this.class.accordionOpen);
			if (isInstant) {
				this.$container.find(this.selector.accordionContent).css('display', 'none');
			} else {
				this.$container.find(this.selector.accordionContent).slideUp(300);
			}

			$item.addClass(this.class.accordionOpen);
			if (isInstant) {
				$item.find(this.selector.accordionContent).css('display', 'block');
			} else {
				$item.find(this.selector.accordionContent).slideDown(300);
			}
			this.$container.trigger('theme:section:filterOptionToggled', [$item, optionId, true]);
		},
		closeFilterItemAccordion: function ($item, isInstant = false) {
			const optionId = $item.attr(this.dataKey.optionId);

			$item.removeClass(this.class.accordionOpen);
			if (isInstant) {
				$item.find(this.selector.accordionContent).css('display', 'none');
			} else {
				$item.find(this.selector.accordionContent).slideUp(300);
			}
			this.$container.trigger('theme:section:filterOptionToggled', [$item, optionId, false]);
		},
		toggleFilterItemAccordion: function ($item, isInstant = false) {
			if ($item.hasClass(this.class.accordionOpen)) {
				this.closeFilterItemAccordion($item, isInstant);
			} else {
				this.openFilterItemAccordion($item, isInstant);
			}
		},
		initFilterItemAccordions: function () {
			const _this = this;
			this.$container.on('click', this.selector.accordionTrigger, function (e) {
				e.preventDefault();
				const $item = $(this).parents(_this.selector.option);
				_this.toggleFilterItemAccordion($item);
			});
		},
		setupListeners: function () {
			const _this = this;
			this.$container.on('change', this.selector.inputCheckbox, function (e) {
				const $checkbox = $(this);
				const optionId = $checkbox.parents(_this.selector.option).attr(_this.dataKey.optionId);
				const optionValue = $checkbox.parents(_this.selector.value).attr(_this.dataKey.optionValue);
				const isChecked = $checkbox.prop('checked');
				_this.$container.trigger(_this.event.optionChanged, [optionId, optionValue, isChecked]);
			});
		},
	},
	init: function () {
		this.filterOption.$container = $(this.container);
		this.filterOption.selector = {
			option: '.js-filter-item',
			value: '.js-filter-item__value',
			inputCheckbox: '.js-filter-item__input-checkbox',
			accordionTrigger: '.js-filter-item__accordion-trigger',
			accordionContent: '.js-filter-item__accordion-content',
		};
		this.filterOption.dataKey = {
			optionId: 'data-option-id',
			optionValue: 'data-option-value',
		};
		this.filterOption.class = {
			accordionOpen: 'is-open',
		};
		this.filterOption.event = {
			optionChanged: 'theme:section:optionChanged',
		};

		this.filterOption.setupListeners();
		this.filterOption.initFilterItemAccordions();
	},
};

Shopify.theme.sections.register('filter-boost-1', {
	pageData: {},
	boostApiData: {},
	filter: {
		selectedOptions: [],
		openedFilters: [],
		lastScrollPos: 0,
	},
	requestBoostApi: async function () {
		const searchParams = new URLSearchParams(document.location.search);
		searchParams.set('shop', 'ted-baker-ksa.myshopify.com');
		searchParams.set('build_filter_tree', 'true');

		let apiEndpoint = 'filter';
		const templateName =
			this.pageData.type.split('.')[0]; /* fix for `collection.promo and other custom templates */
		this.pageData.type = templateName;

		switch (this.pageData.type) {
			case 'collection':
				searchParams.delete('tag[]');
				this.pageData.collectionTags.split(',').forEach((tag) => searchParams.append('tag[]', tag));

				searchParams.set('collection_scope', this.pageData.collectionId || '0');
				apiEndpoint = 'filter';
				break;
			case 'search':
				searchParams.set('q', this.pageData.searchTerms);
				apiEndpoint = 'search';
				break;
		}

		await $.ajax({
			url: `https://services.mybcapps.com/bc-sf-filter/${apiEndpoint}?${searchParams.toString()}`,
			method: 'get',
			dataType: 'jsonp',
			success: (data, textStatus, jqXHR) => {
				this.boostApiData = data;
			},
		});
	},
	compileTemplate: function (templateName, params = {}) {
		const data = this.boostApiData;

		switch (templateName) {
			case 'filter': {
				let $template = $(this.container).find('.t-filter');
				return $template
					.html()
					.replace(/{{header}}/g, this.compileTemplate('filter-header'))
					.replace(/{{filterOptions}}/g, this.compileTemplate('filter-options'))
					.replace(/{{footer}}/g, this.compileTemplate('filter-footer'));
			}
			case 'filter-header': {
				let $template = $(this.container).find('.t-filter-header');
				return $template.html().replace(/{{title}}/g, this.compileTemplate('filter-header-title'));
			}
			case 'filter-header-title': {
				if (data.total_product === 1) {
					let $template = $(this.container).find('.t-filter-header-title-single');
					return $template.html();
				} else {
					let $template = $(this.container).find('.t-filter-header-title-multiple');
					return $template.html().replace(/{{ count }}/g, data.total_product);
				}
			}
			case 'filter-footer': {
				let $template = $(this.container).find('.t-filter-footer');
				return $template
					.html()
					.replace(/{{applyFilterButton}}/g, this.compileTemplate('filter-apply-button'))
					.replace(/{{clearFilterButton}}/g, this.compileTemplate('filter-clear-button'));
			}
			case 'filter-options': {
				let $template = $(this.container).find('.t-filter-option');
				let templateHtml = '';
				const filterOptions = data.filter.options.filter(
					(option) =>
						option.status === 'active' && option.displayType === 'list' && option.values.length > 0,
				);
				for (let option of filterOptions) {
					templateHtml += $template
						.html()
						.replace(/{{title}}/g, option.label)
						.replace(/{{id}}/g, `${option.filterOptionId}[]`)
						.replace(
							/{{filterOptionItems}}/g,
							this.compileTemplate('filter-option-values', { filterOption: option }),
						);
				}
				return templateHtml;
			}
			case 'filter-apply-button': {
				let $template = $(this.container).find('.t-filter-apply-button');
				return $template.html();
			}
			case 'filter-clear-button': {
				let $template = $(this.container).find('.t-filter-clear-button');
				return $template.html().replace(/{{ count }}/g, this.filter.selectedOptions.length);
			}
			case 'filter-option-values': {
				let $template = $(this.container).find('.t-filter-option-value');
				let templateHtml = '';

				// redefine variables based on filter type
				switch (params.filterOption.filterType) {
					case 'collection':
						$template = $(this.container).find('.t-filter-option-value-link');
						break;
				}

				for (let [index, valueObj] of Object.entries(params.filterOption.values)) {
					let title = valueObj.key;
					let value = valueObj.key;
					let link = '';
					let cssClass = '';

					// redefine variables based on filter type
					switch (params.filterOption.filterType) {
						case 'collection':
							title = valueObj.label;
							value = valueObj.handle;
							link = `${window.theme.routes.collections}/${valueObj.handle}`;
							if (window.location.pathname.split('/').pop().split('?')[0] === valueObj.handle) {
								cssClass += ' is-active';
							}
							break;
						case 'price':
							value = params.filterOption.manualValues[index];

							title = '';
							const currency = params.filterOption.moneyFormatValue.replace(/{{.*}}/, '');

							if (valueObj.from) {
								const stringEN = `${valueObj.from + currency}`;
								const stringAR = `${currency + ' ' + valueObj.to}`;

								if (window.Shopify.locale == 'ar') {
									title += stringAR;
								} else {
									title += stringEN;
								}

								if (valueObj.to) {
									title += ' - ';
								} else {
									const stringAR = `${currency + ' ' + valueObj.from}`;
									if (window.Shopify.locale == 'ar') {
										title = window.theme.strings.collections.filter.price_more.replace(
											/{{.*}}/,
											stringAR,
										);
									} else {
										title = window.theme.strings.collections.filter.price_more.replace(
											/{{.*}}/,
											stringEN,
										);
									}
								}
							}
							if (valueObj.to) {
								const stringEN = `${valueObj.to + currency}`;
								const stringAR = `${currency + ' ' + valueObj.from}`;

								if (window.Shopify.locale == 'ar') {
									title += stringAR;
								} else {
									title += stringEN;
								}

								if (!valueObj.from) {
									const stringAR = `${currency + ' ' + valueObj.to}`;
									if (window.Shopify.locale == 'ar') {
										title = window.theme.strings.collections.filter.price_less.replace(
											/{{.*}}/,
											stringAR,
										);
									} else {
										title = window.theme.strings.collections.filter.price_less.replace(
											/{{.*}}/,
											stringEN,
										);
									}
								}
							}

							break;
					}

					templateHtml += $template
						.html()
						.replace(/{{title}}/g, title)
						.replace(/{{value}}/g, value)
						.replace(/{{link}}/g, link)
						.replace(/{{class}}/g, cssClass)
						.replace(/{{count}}/g, valueObj.doc_count);
				}
				return templateHtml;
			}
		}
	},
	renderFilter: function () {
		// remember our last scroll position
		this.filter.lastScrollPos = $(this.container).find('.js-filter__content-scroll').scrollTop();

		// re-render filter
		$(this.container).find('.js-filter__container').html(this.compileTemplate('filter'));

		// select active option values
		this.filter.selectedOptions.forEach((option) => {
			this.filterOption.toggleOptionValue(option.id, option.value);
		});

		// open active filter options
		this.filter.openedFilters.forEach((optionId) => {
			const $filter = this.filterOption.getOption(optionId);
			this.filterOption.openFilterItemAccordion($filter, true);
		});

		// apply our last scroll position to newly rendered filter
		$(this.container).find('.js-filter__content-scroll').scrollTop(this.filter.lastScrollPos);
	},
	updateFilter: function () {
		$(this.container)
			.find('.js-filter__header-title')
			.html(this.compileTemplate('filter-header-title'));
		$(this.container)
			.find('.js-filter__clear-button')
			.replaceWith(this.compileTemplate('filter-clear-button'));
		this.renderFilter();
		$('body').trigger('theme:collectionFilterUpdated', [
			this.boostApiData,
			this.filter.selectedOptions,
		]);
	},
	readUrl: function () {
		const searchParams = new URLSearchParams(document.location.search);
		searchParams.forEach((value, key) => {
			if (key.startsWith('pf_')) {
				this.filter.selectedOptions.push({
					id: key,
					value: value,
				});
			}
		});
	},
	writeUrl: function () {
		let url = new URL(window.location);

		// delete page param
		url.searchParams.delete('page');

		// remove previous filter params
		url.searchParams.forEach((value, key) => {
			if (key.startsWith('pf_')) {
				url.searchParams.delete(key);
			}
		});

		// add new filter params
		this.filter.selectedOptions.forEach((option) => {
			url.searchParams.append(option.id, option.value);
		});

		// generate new URL and trigger update
		const urlString = url.toString();
		window.history.pushState({ path: urlString }, '', urlString);
		window.dispatchEvent(new Event('popstate'));
	},
	setupListeners: function () {
		$(this.container).on('theme:section:optionChanged', (e, optionId, optionValue, isChecked) => {
			if (isChecked) {
				this.filter.selectedOptions.push({ id: optionId, value: optionValue });
			} else {
				this.filter.selectedOptions.splice(
					this.filter.selectedOptions.findIndex(
						(option) => option.id === optionId && option.value === optionValue,
					),
					1,
				);
			}
			this.writeUrl();
			this.requestBoostApi().then(() => {
				this.updateFilter();
			});
		});
		$(this.container).on('click', '.js-filter__clear-button', (e) => {
			this.filter.selectedOptions.forEach((option) => {
				this.filterOption.toggleOptionValue(option.id, option.value);
			});
			this.filter.selectedOptions = [];
			this.writeUrl();
			this.requestBoostApi().then(() => {
				this.updateFilter();
			});
		});
		$(this.container).on('theme:section:filterOptionToggled', (e, $item, optionId, isOpen) => {
			if (isOpen) {
				this.filter.openedFilters.push(optionId);
			} else {
				this.filter.openedFilters = this.filter.openedFilters.filter(
					(option) => option !== optionId,
				);
			}
		});
	},
	checkPageType: function () {
		const pageType = $(this.container).attr('data-page-type');
		this.pageData.type = pageType;

		switch (pageType) {
			case 'collection':
				this.pageData.collectionId = $(this.container).attr('data-collection-id');
				this.pageData.collectionTags = $(this.container).attr('data-collection-tags');
				break;
			case 'search':
				this.pageData.searchTerms = $(this.container).attr('data-search');
				break;
		}
	},
	removeFilterOption: function (optionId) {
		this.filter.selectedOptions = this.filter.selectedOptions.filter(
			(option) => option.id !== optionId,
		);
		this.writeUrl();
		this.requestBoostApi().then(() => {
			this.updateFilter();
		});
	},
	onLoad: function () {
		this.extend(drawerExtension);
		this.extend(filterItem1Extension);

		this.checkPageType();

		this.requestBoostApi().then(() => {
			this.readUrl();
			this.updateFilter();
			this.setupListeners();
		});
	},
});

Shopify.theme.sections.register('sort-boost-1', {
	onLoad: function () {
		this.extend(drawerExtension);
	},
});

Shopify.theme.sections.register('scroller-1', {
	getPoints: function () {
		let points = [];
		$(this.container)
			.find('.js-scroll-button')
			.each((i, elem) => {
				const $button = $(elem);
				const $targetSectionNode = $(`${$button.attr('href')}`);
				if ($targetSectionNode.length > 0) {
					// let sectionPoint = $targetSectionNode.offset().top + ($targetSectionNode.outerHeight() / 2);
					let sectionPoint = $targetSectionNode.offset().top;
					points.push(sectionPoint);
					$button.attr('data-target-scrolltop', sectionPoint);
				}
			});
		return points;
	},
	toggleActiveScroll: function () {
		var closest = this.points.reduce(function (prev, curr) {
			return Math.abs(curr - $(window).scrollTop()) < Math.abs(prev - $(window).scrollTop())
				? curr
				: prev;
		});
		$(this.container).find('.js-scroll-button').removeClass('is-active');
		$(this.container)
			.find('.js-scroll-button')
			.filter(`[data-target-scrolltop="${closest}"]`)
			.addClass('is-active');
	},
	initScrollDetection: function () {
		this.points = this.getPoints();
		if (!this.points.length) {
			return;
		}
		this.toggleActiveScroll();
		$(window).on('resize', (e) => {
			this.points = this.getPoints();
		});
		$(window).on('scroll resize', (e) => {
			this.toggleActiveScroll();
		});
	},
	onLoad: function () {
		this.extend(scrollButtonExtension);

		this.initScrollDetection();
	},
});

Shopify.theme.sections.register('look-guide-1', {
	toggleItemContent: function ($item) {
		if ($item.find(this.itemContentSelector).hasClass(this.itemContentOpenClass)) {
			$(this.container).find(this.itemContentSelector).removeClass(this.itemContentOpenClass);
		} else {
			$(this.container).find(this.itemContentSelector).removeClass(this.itemContentOpenClass);
			$item.find(this.itemContentSelector).addClass(this.itemContentOpenClass);
		}
	},
	initItemContent: function () {
		this.itemSelector = '.js-look-item';
		this.itemTriggerSelector = '.js-toggle-content';
		this.itemContentSelector = '.js-item-content';
		this.itemContentOpenClass = 'is-open';

		const _this = this;
		$(this.container).on('click', this.itemTriggerSelector, function (e) {
			e.preventDefault();
			_this.toggleItemContent($(this).parents(_this.itemSelector));
		});
	},
	onLoad: function () {
		this.initItemContent();
	},
});

Shopify.theme.sections.register('lookbook-1', {
	switchColor: function (colorId) {
		const $curImageNode = $(this.colorImageSelector).filter(`.${this.colorTriggerActiveClass}`);
		const $targetSwatchNode = $(this.colorTriggerSelector).filter(
			`[${this.colorDataKey}="${colorId}"]`,
		);
		const $targetImageNode = $(this.colorImageSelector).filter(
			`[${this.colorDataKey}="${colorId}"]`,
		);
		const $targetColumnNode = $targetSwatchNode.parents('.js-column');

		if ($targetSwatchNode.hasClass(this.colorTriggerActiveClass)) {
			return;
		}

		$targetColumnNode.find(this.colorImageSelector).removeClass(this.colorImagePrevClass);
		$curImageNode.addClass(this.colorImagePrevClass);

		$targetColumnNode.find(this.colorTriggerSelector).removeClass(this.colorTriggerActiveClass);
		$targetColumnNode.find(this.colorImageSelector).removeClass(this.colorImageActiveClass);

		$targetSwatchNode.addClass(this.colorTriggerActiveClass);
		$targetImageNode.addClass(this.colorImageActiveClass);
	},
	initColorsSwitch: function () {
		this.colorTriggerSelector = '.js-swatch-button';
		this.colorTriggerActiveClass = 'is-active';
		this.colorImageSelector = '.js-color-image';
		this.colorImageActiveClass = 'is-active';
		this.colorImagePrevClass = 'is-prev';
		this.colorDataKey = 'data-color-id';
		this.columnDataKey = 'data-column-id';

		const _this = this;
		$(this.colorTriggerSelector).on('click', function () {
			_this.switchColor($(this).attr(_this.colorDataKey));
		});
	},
	onLoad: function () {
		this.initColorsSwitch();
	},
});

const productOption1Extension = {
	init: function () {
		const optionSelector = '.js-product-option';
		const optionMasterSelectSelector = '.js-product-option__master-select';
		const optionValueSelector = '.js-product-option__value';
		const optionValueDataKey = 'data-option-value';
		const optionValueActiveClass = 'is-selected';
		const optionSelectedValueSelector = '.js-product-option__selected-value';

		const updateMasterSelect = ($optionNode, value) => {
			const $masterSelectNode = $optionNode.find(optionMasterSelectSelector);
			$masterSelectNode.val(value).trigger('change');
			$masterSelectNode.get(0).dispatchEvent(new Event('change'));

			$(this.container).trigger('theme:section:onProductOptionChange', [$masterSelectNode, value]);
		};
		const selectOptionValue = ($optionNode, value, label) => {
			$optionNode.find(optionValueSelector).removeClass(optionValueActiveClass);
			$optionNode
				.find(optionValueSelector)
				.filter(`[${optionValueDataKey}="${encodeURI(value)}"]`)
				.addClass(optionValueActiveClass);
			$optionNode.find(optionSelectedValueSelector).text(label || value);
			$optionNode.find(optionSelectedValueSelector).removeClass('is-not-selected');
			updateMasterSelect($optionNode, value);
		};

		$(this.container).on('click', optionValueSelector, function (e) {
			e.preventDefault();
			const $optionNode = $(this).parents(optionSelector);
			const value = $(this).attr(optionValueDataKey);
			// todo: create an attr for label
			const label = $(this).attr('aria-label');
			selectOptionValue($optionNode, value, label);
			closeOptionDropdown($optionNode);
		});

		/** Option Dropdown */

		const dropdownAnimationDuration = 297; // ms
		const optionDropdownTriggerSelector = '.js-product-option__dropdown-trigger';
		const optionDropdownContainerSelector = '.js-product-option__dropdown-container';
		const optionDropdownOpenClass = 'is-dropdown-open';

		/**
		 * Tether Dropdown is a dropdown placed in the body root to apply specific positioning using Tetherjs library
		 * */
		const buildTetherDropdown = ($targetOptionNode) => {
			const triggerElement = $targetOptionNode.find(optionDropdownTriggerSelector).get(0);
			const dropdownElement = $targetOptionNode.find(optionDropdownContainerSelector).get(0);

			$(dropdownElement).css('width', `${$targetOptionNode.outerWidth()}px`);

			return ($targetOptionNode.get(0).tether = new Tether({
				element: dropdownElement,
				target: triggerElement,
				attachment: 'top left',
				targetAttachment: 'bottom left',
				targetModifier: 'visible',
				constraints: [
					{
						to: 'scrollParent',
						attachment: 'together',
					},
				],
			}));
		};
		const destroyTetherDropdown = ($targetOptionNode) => {
			const triggerElement = $targetOptionNode.find(optionDropdownTriggerSelector).get(0);
			const $tetherDropdown = $($targetOptionNode.get(0).tether.element);

			$targetOptionNode.get(0).tether.destroy();
			$tetherDropdown.removeAttr('style');
			$tetherDropdown.insertAfter(triggerElement);
		};
		const openOptionDropdown = ($targetOptionNode) => {
			if ($targetOptionNode.hasClass(optionDropdownOpenClass)) return;

			const tether = buildTetherDropdown($targetOptionNode);
			const $tetherDropdown = $(tether.element);

			// wait until the tether is activated then open the dropdown
			setTimeout(() => {
				$targetOptionNode.addClass(optionDropdownOpenClass);
				$tetherDropdown.addClass(optionDropdownOpenClass);
			}, 0);

			// close dropdown when click outside
			$targetOptionNode.get(0).outsideClickHandler = function (e) {
				if (
					!$(e.target).parents().addBack().is($targetOptionNode) &&
					!$(e.target).parents().addBack().is($tetherDropdown)
				) {
					closeOptionDropdown($targetOptionNode);
				}
			};
			$(document).on('click.productOption1Dropdown', $targetOptionNode.get(0).outsideClickHandler);

			// close dropdown when scroll
			$targetOptionNode.get(0).scrollParentElement =
				tether.scrollParents[0] === tether.bodyElement ? window : tether.scrollParents[0];
			$($targetOptionNode.get(0).scrollParentElement).on('scroll.productOption1Dropdown', () => {
				closeOptionDropdown($targetOptionNode);
			});

			// select value from tethered dropdown
			$tetherDropdown.on('click.productOption1DropdownValue', optionValueSelector, function (e) {
				e.preventDefault();
				const value = $(this).attr(optionValueDataKey);
				const label = $(this).attr('aria-label');
				closeOptionDropdown($targetOptionNode);
				selectOptionValue($targetOptionNode, value, label);
			});
		};
		const closeOptionDropdown = ($targetOptionNode) => {
			if (!$targetOptionNode.hasClass(optionDropdownOpenClass)) return;

			const tether = $targetOptionNode.get(0).tether;
			const $tetherDropdown = $(tether.element);

			$targetOptionNode.removeClass(optionDropdownOpenClass);
			$tetherDropdown.removeClass(optionDropdownOpenClass);

			$(document).off('click.productOption1Dropdown', $targetOptionNode.get(0).outsideClickHandler);
			$($targetOptionNode.get(0).scrollParentElement).off('scroll.productOption1Dropdown');
			$tetherDropdown.off('click.productOption1DropdownValue');

			setTimeout(() => {
				destroyTetherDropdown($targetOptionNode);
			}, dropdownAnimationDuration);
		};
		const toggleOptionDropdown = ($targetOptionNode) => {
			if ($targetOptionNode.hasClass(optionDropdownOpenClass)) {
				closeOptionDropdown($targetOptionNode);
			} else {
				openOptionDropdown($targetOptionNode);
			}
		};

		$(this.container).on('click', optionDropdownTriggerSelector, function (e) {
			e.preventDefault();
			toggleOptionDropdown($(this).parents(optionSelector));
		});
	},
};

const productForm1Extension = {
	productJSON: {},
	productFormData: {},
	productFormEventData: {},
	initProductForm: async function () {
		const _this = this;
		const productFormSelector = '.js-product-form';
		const productHandle = $(this.container).find(productFormSelector).attr('data-product-handle');

		const loadProductData = async () => {
			await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`, {
				mode: 'cors',
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
					'Content-Type': 'application/json;',
				},
				credentials: 'same-origin',
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error('loadProductData error');
					}
					return response.json();
				})
				.then((productJSON) => {
					this.productJSON = productJSON;
				})
				.catch((error) => {
					// console.log(error);
				});
		};
		setTimeout(() => { check_bloomreach_product_json () }, 1000);
		setTimeout(() => { check_bloomreach_product_json () }, 3000);
		setTimeout(() => { check_bloomreach_product_json ()}, 6000);
		function check_bloomreach_product_json () {
			if ( !$('#bloomreach_product_json').length && !$('.is-not-selected').length && $("body").hasClass("template-product") ) reloadProductForm();
		}
		const onOptionChange = (event) => {
			this.productFormEventData = { ...event.dataset };

			const variant = event.dataset.variant;
			const url = Shopify.theme.productForm.getUrlWithVariant(window.location.href, variant.id);
			window.history.replaceState({ path: url }, '', url);

			reloadProductForm();

			$('body').trigger('theme:onProductVariantChange', [
				this.productFormEventData,
				this.productFormData,
			]);

			window.dispatchEvent(
				new CustomEvent('product:variantChange', {
					detail: { data: [this.productFormEventData, this.productFormData] }, // Optional data to pass along with the event
					bubbles: true, // Specify whether the event should bubble up through the DOM or not
					cancelable: true, // Specify whether the event is cancelable or not
				}),
			);
		};
		const reloadProductForm = () => {
			const variant = this.productFormEventData.variant;
			if (!variant || !variant.id) { return; }
			const urlWithVariant = Shopify.theme.productForm.getUrlWithVariant(
				window.location.href,
				variant.id,
			);

			$.ajax(urlWithVariant + '&section_id=' + this.id, {
				method: 'GET',
				dataType: 'html',
				success: (data) => {
					const newForm = $(data).find(productFormSelector);
					$(this.container).find(productFormSelector).replaceWith(newForm);
					setupProductForm();
					// func_bloomreach_product_json(false, false, false, variant.id, false, false) // EXPONEA exponea bloomreach  <!-- EXPONEA start -->
					func_bloomreach_changeVariant_TB(variant.id, this.id) 
				},
			});
		};
		const setupProductForm = () => {
			this.productFormData = new Shopify.theme.productForm.ProductForm(
				this.container.querySelector(productFormSelector),
				this.productJSON,
				{
					onOptionChange: onOptionChange,
				},
			);
			this.productFormEventData = { ...this.productFormData._getProductFormEventData() };
		};
		const triggerReadyListeners = () => {
			$('body').trigger('theme:productFormReady', [
				this.productFormEventData,
				this.productFormData,
			]);
		};
		const handleStickyVisibility = () => {
			let isSticky = false;

			const setStickyVisibility = () => {
				const scrollTop = $(window).scrollTop();
				const mainCartButtonTop = $(this.container)
					.find('.js-sticky-visibility-trigger')
					.offset().top;
				const $stickyContainer = $(this.container).find('.js-product-sticky');
				if (scrollTop > mainCartButtonTop) {
					if (!isSticky) {
						$stickyContainer.addClass('is-open');
						isSticky = true;
					}
				} else {
					if (isSticky) {
						$stickyContainer.removeClass('is-open');
						isSticky = false;
					}
				}
			};

			$(window).on('scroll resize load', throttle(setStickyVisibility, 100));
		};
		const validateForm = () => {
			let isValid = true;

			if (!$(this.container).find(productFormSelector).hasClass('is-variant-selected')) {
				$(this.container)
					.find('.js-product-option')
					.each((i, productOption) => {
						if (
							$(productOption)
								.find('.js-product-option__selected-value')
								.hasClass('is-not-selected')
						) {
							$(productOption).addClass('is-error');
							isValid = false;
						} else {
							$(productOption).removeClass('is-error');
						}
					});
			}

			if (!isValid)
				scrollToElement(
					$(this.container).find('.js-product-option.is-error').first(),
					undefined,
					-100,
				);

			return isValid;
		};
		const handleAddToCart = () => {
			$(this.container).on('submit', productFormSelector, function (e) {
				e.preventDefault();

				if (!validateForm()) return false;

				$(_this.container)
					.find('.js-cart-button')
					.attr('disabled', 'disabled')
					.addClass('is-loading');
				Shopify.theme.cart
					.addItemFromForm(this)
					.then((item) => {
						$('body').one('theme:onCartUpdate', () => {
							setTimeout(() => {
								$(_this.container).find('.js-cart-button').removeAttr('disabled');
							}, 400);
						});
						document.body.dispatchEvent(new CustomEvent("theme:onCartItemAdd", { detail: [item] }));
					})
					.catch((err) => {
						// console.log(err);
					})
					.finally(() => {
						setTimeout(() => {
							$(_this.container).find('.js-cart-button').removeClass('is-loading');
						}, 400);
					});
			});
		};

		await loadProductData();
		setupProductForm();
		triggerReadyListeners();
		handleAddToCart();
		handleStickyVisibility();

		$('body').on('theme:triggerProductForm', triggerReadyListeners);
	},
	init: function () {
		this.extend(productOption1Extension);
		this.extend(navAccordionExtension);
	},
};

Shopify.theme.sections.register('product-1', {
	filteredSlides: [],
	initWishlistButton: function () {
		window.WishlistKing.observe(
			{
				selector: `[data-section-id="${this.id}"] .js-wishlist-button`,
				template: 'product',
			},
			(target) => {
				target.append(
					window.WishlistKing.createComponent('wishlist-button', {
						id: `${this.productFormData.product.id}`,
					}),
				);
			},
		);
	},
	initSizeButton: function () {
		$(this.container).on('click', '.js-size-button', function (e) {
			e.preventDefault();
			$('body').trigger('theme:openDrawer', ['size-drawer']);
		});
	},
	initMediaZoomButton: function () {
		$(this.container).on('click', '.js-product-media-drawer', function (e) {
			e.preventDefault();
			$('body').trigger('theme:openDrawer', ['product-media-drawer']);
		});
	},
	initMediaSlider: function () {
		const handleSlidesCount = (swiper) => {
			if (swiper.slidesGrid.length > 1) {
				$(this.container).find('.js-slider-count').removeClass('hide');
				$(this.container)
					.find('.js-slider-count')
					.text(swiper.activeIndex + 1 + ' | ' + swiper.slidesGrid.length);
			} else {
				$(this.container).find('.js-slider-count').addClass('hide');
			}
		};
		const getMediaData = (mediaId) => {
			return this.productFormData.product.media.find((media) => +media.id === +mediaId);
		};
		const filterSlidesBySwatches = (swiper, productFormEventData = this.productFormEventData) => {
			let $slides = $(swiper.slides);
			const swatchesTrigger = window.theme.settings.swatchesTrigger;
			const isSwatchesEnabled = $(this.container).attr('data-enable-swatches') === 'true';

			if (!isSwatchesEnabled) return;

			let newFilteredSlides = [];
			$slides.each((index, slide) => {
				const slideId = $(slide).attr('data-media-id');
				const slideSwatch = getMediaData(slideId).alt;
				for (let option of productFormEventData.options) {
					if ((option.name === swatchesTrigger && slideSwatch === option.value) || !slideSwatch) {
						newFilteredSlides.push(index);
					}
				}
			});

			if (JSON.stringify(this.filteredSlides) !== JSON.stringify(newFilteredSlides)) {
				this.filteredSlides = [...newFilteredSlides];

				$slides.removeClass('hide');
				$slides.filter((index) => !this.filteredSlides.includes(index)).addClass('hide');

				swiper.update();
				swiper.slideTo(0);
			}
		};

		this.swiperSlider = new Swiper($(this.container).find('.js-slider').get(0), {
			slidesPerView: 1,
			rewind: true,
			cssMode: false,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
			},
			on: {
				init: function (swiper) {
					handleSlidesCount(swiper);
					filterSlidesBySwatches(swiper);
				},
				update: function (swiper) {
					handleSlidesCount(swiper);
				},
				slideChange: function (swiper) {
					handleSlidesCount(swiper);
				},
			},
		});

		$('body').on('theme:onProductVariantChange', (e, productFormEventData) => {
			filterSlidesBySwatches(this.swiperSlider, productFormEventData);
		});
	},
	onLoad: function () {
		this.extend(productForm1Extension);
		this.initProductForm().then(() => {
			this.initMediaSlider();
			this.initMediaZoomButton();

			this.initSizeButton();

			// if (window.WishlistKing) {
			// 	this.initWishlistButton();
			// } else {
			// 	$('body').on('app:wishlistKing:ready', (e) => {
			// 		this.initWishlistButton();
			// 	});
			// }
		});
	},
});

Shopify.theme.sections.register('product-media-drawer', {
	filteredSlides: [],
	initMediaSlider: function () {
		const hadnleSliderArrows = (swiper) => {
			if (swiper.slidesGrid.length > 1) {
				$(this.container).find('.js-arrow-wrap').removeClass('hide');
			} else {
				$(this.container).find('.js-arrow-wrap').addClass('hide');
			}
		};
		const handleSlidesCount = (swiper) => {
			if (swiper.slidesGrid.length > 1) {
				$(this.container).find('.js-slider-count').removeClass('hide');
				$(this.container)
					.find('.js-slider-count')
					.text(swiper.activeIndex + 1 + ' | ' + swiper.slidesGrid.length);
			} else {
				$(this.container).find('.js-slider-count').addClass('hide');
			}
		};
		const getMediaData = (mediaId, productFormData) => {
			return productFormData.product.media.find((media) => +media.id === +mediaId);
		};
		const filterSlidesBySwatches = (swiper, productFormEventData, productFormData) => {
			if (!productFormEventData || !productFormData) return;

			let $slides = $(swiper.slides);
			const swatchesTrigger = window.theme.settings.swatchesTrigger;
			const isSwatchesEnabled = $(this.container).attr('data-enable-swatches') === 'true';

			if (!isSwatchesEnabled) return;

			let newFilteredSlides = [];
			$slides.each((index, slide) => {
				const slideId = $(slide).attr('data-media-id');
				const slideSwatch = getMediaData(slideId, productFormData).alt;
				for (let option of productFormEventData.options) {
					if ((option.name === swatchesTrigger && slideSwatch === option.value) || !slideSwatch) {
						newFilteredSlides.push(index);
					}
				}
			});

			if (JSON.stringify(this.filteredSlides) !== JSON.stringify(newFilteredSlides)) {
				this.filteredSlides = [...newFilteredSlides];

				$slides.removeClass('hide');
				$slides.filter((index) => !this.filteredSlides.includes(index)).addClass('hide');

				swiper.update();
				swiper.slideTo(0);
			}
		};

		this.swiperSlider = new Swiper($(this.container).find('.js-slider').get(0), {
			slidesPerView: 1,
			rewind: true,
			cssMode: true,
			navigation: {
				prevEl: '.js-slider-prev',
				nextEl: '.js-slider-next',
			},
			on: {
				init: function (swiper) {
					handleSlidesCount(swiper);
					hadnleSliderArrows(swiper);
				},
				update: function (swiper) {
					handleSlidesCount(swiper);
					hadnleSliderArrows(swiper);
				},
				slideChange: function (swiper) {
					handleSlidesCount(swiper);
				},
			},
		});

		$('body').on('theme:productFormReady', (e, productFormEventData, productFormData) => {
			filterSlidesBySwatches(this.swiperSlider, productFormEventData, productFormData);
		});
		$('body').on('theme:onProductVariantChange', (e, productFormEventData, productFormData) => {
			filterSlidesBySwatches(this.swiperSlider, productFormEventData, productFormData);
		});
	},
	onLoad: function () {
		this.extend(drawerExtension);

		this.initMediaSlider();
		$('body').trigger('theme:triggerProductForm');
	},
});

Shopify.theme.sections.register('gift-card-product-1', {
	onLoad: function () {
		this.extend(productForm1Extension);
		this.initProductForm();
	},
});

const cartItem1Extension = {
	init: function () {
		this.extend(productOption1Extension);

		const _this = this;
		const itemSelector = '.js-cart-item-1';
		const removeButtonSelector = '.js-cart-item-1__remove-item';

		$(this.container).on('click', removeButtonSelector, function (e) {
			e.preventDefault();

			const $item = $(this).parents(itemSelector);
			const itemKey = $item.attr('data-item-key');

			Shopify.theme.cart.removeItem(itemKey).then((cartState) => {
				document.body.dispatchEvent(new CustomEvent('theme:onCartItemRemove', { detail: [undefined, cartState] }));
				// $('body').trigger('theme:onCartItemRemove', [undefined, cartState]);
			});
		});

		$(this.container).on('theme:section:onProductOptionChange', (e, $input, value) => {
			e.preventDefault();

			const $item = $input.parents(itemSelector);
			const itemKey = $item.attr('data-item-key');

			if ($input.attr('name') === 'updates[]') {
				Shopify.theme.cart.updateItem(itemKey, { quantity: +value }).then((cartState) => {
					document.body.dispatchEvent(new CustomEvent('theme:onCartItemUpdate', { detail: [undefined, cartState] }));
					// $('body').trigger('theme:onCartItemUpdate', [undefined, cartState]);
				});
			}
		});
	},
};

Shopify.theme.sections.register('cart-1', {
	onLoad: function () {
		this.extend(cartItem1Extension);

		const containerSelector = `[data-section-id="${this.id}"]`;

		const reloadCart = () => {
			const url = window.location.pathname + '?section_id=' + this.id;
			$.ajax(url, {
				method: 'GET',
				dataType: 'html',
				success: (data) => {
					const newCart = $(data).find(containerSelector).html();
					$(this.container).html(newCart);
				},
			});
		};

		$('body').on(
			'theme:onCartItemAdd theme:onCartItemRemove theme:onCartItemUpdate',
			(e, item, cartState) => {
				reloadCart();
				$('body').trigger('theme:onCartUpdate', [cartState]);
			},
		);
	},
});

const cfFormExtension = {
	init: function () {
		const _this = this;
		CF.ready(function () {
			const $form = $(_this.container).find('form[data-cf-form]');
			$form.each(function () {
				// const cfForm = this.cfForm;

				// wrap input for some fields to apply specific styles
				const fieldTypes = ['text', 'password', 'email'];
				const $fields = $(this)
					.find('.cf-field')
					.filter((i, field) => fieldTypes.includes($(field).attr('data-cf-field-type')));
				$fields.find('input').wrap($(`<div class="cf-input-wrap"></div>`));
			});
		});
	},
};

Shopify.theme.sections.register('authentication-1', {
	onLoad: function () {
		this.extend(cfFormExtension);

		const _this = this;
		const handleAccountBlockSwitch = () => {
			const blockSelector = '.js-account-block';
			const triggerSelector = '.js-switch-account-block';
			const blockDataKey = 'data-account-block';

			$(this.container).on('click', triggerSelector, function (e) {
				e.preventDefault();

				const targetBlock = $(this).attr(blockDataKey);

				$(_this.container).find(blockSelector).addClass('hide');
				$(_this.container)
					.find(blockSelector)
					.filter(`[${blockDataKey}="${targetBlock}"]`)
					.removeClass('hide');
			});
		};
		const handleFormSwitch = () => {
			const formSelector = '.js-form-wrap';
			const triggerSelector = '.js-switch-form';
			const formDataKey = 'data-form';

			const getFormFromURL = () => {
				const url = new URL(window.location.href);

				return url.searchParams.get(formDataKey);
			};
			const putFormToURL = (form) => {
				const url = new URL(window.location);
				url.searchParams.set(formDataKey, form);
				const urlString = url.toString();
				window.history.replaceState({ path: urlString }, '', urlString);
			};
			const toggleForm = (form) => {
				$(_this.container).find(formSelector).addClass('hide');
				$(_this.container)
					.find(formSelector)
					.filter(`[${formDataKey}="${form}"]`)
					.removeClass('hide');
			};

			$(this.container).on('click', triggerSelector, function (e) {
				e.preventDefault();

				const targetForm = $(this).attr(formDataKey);

				toggleForm(targetForm);
				putFormToURL(targetForm);
			});

			const activeForm = getFormFromURL();
			if (activeForm) {
				toggleForm(activeForm);
			}
		};

		handleAccountBlockSwitch();
		handleFormSwitch();
	},
});

Shopify.theme.sections.register('reset-password', {
	initFormValidation: function () {
		const password = this.container.querySelector('.js-reset-password__password');
		const confirm = this.container.querySelector('.js-reset-password__password-confirmation');

		const regex = new RegExp(password.dataset.regex);
		password.onchange = () => {
			if (!regex.test(password.value)) {
				password.setCustomValidity(password.dataset.regexError || 'Password is not valid');
			} else {
				password.setCustomValidity('');
			}
		};

		confirm.onchange = () => {
			if (confirm.value !== password.value) {
				confirm.setCustomValidity(confirm.dataset.regexError || 'Passwords do not match');
			} else {
				confirm.setCustomValidity('');
			}
		};
	},
	onLoad: function () {
		this.initFormValidation();
	},
});

Shopify.theme.sections.register('account-1', {
	onLoad: function () {
		this.extend(navAccordionExtension);

		const _this = this;

		const handleFormToggle = () => {
			const triggerSelector = '.js-toggle-address-form-wrap';
			const formWrapSelector = '.js-address-form-wrap';
			const formWrapDataKey = 'data-address-form-wrap';
			$(this.container).on('click', triggerSelector, function (e) {
				e.preventDefault();
				const targetFormWrap = $(this).attr(formWrapDataKey);
				$(_this.container).find(triggerSelector).toggleClass('is-active');
				$(_this.container)
					.find(formWrapSelector)
					.filter(`[${formWrapDataKey}="${targetFormWrap}"]`)
					.slideToggle(300);
			});
		};
		const handleFormAddressCountry = () => {
			if (Shopify) {
				$(this.container)
					.find('.js-address-form__country')
					.each(function () {
						const $form = $(this).parents('.js-address-form');
						const countryId = $(this).attr('id');
						const provinceId = $form.find('.js-address-form__province').attr('id');
						const provinceContainerId = $form.find('.js-address-form__province-wrap').attr('id');

						new Shopify.CountryProvinceSelector(countryId, provinceId, {
							hideElement: provinceContainerId,
						});
					});
			}
		};
		const handleAddressDelete = () => {
			if (Shopify) {
				$(this.container).on('click', '.js-address-delete', function (e) {
					e.preventDefault();
					const addressId = $(this).attr('data-address');
					const confirmMessage = $(this).attr('data-confirm-message');
					if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
						Shopify.postLink(`${Shopify.routes.root}account/addresses/` + addressId, {
							parameters: { _method: 'delete' },
						});
					}
				});
			}
		};

		handleFormToggle();
		handleFormAddressCountry();
		handleAddressDelete();
	},
});

Shopify.theme.sections.register('localization-drawer', {
	onLoad: function () {
		this.extend(drawerExtension);
		this.extend(productOption1Extension);
	},
});

Shopify.theme.sections.register('size-drawer', {
	onLoad: function () {
		this.extend(drawerExtension);
	},
});

Shopify.theme.sections.register('wishlist-1', {
	initWishlistPage: function () {
		window.WishlistKing.observe(
			{
				selector: `[data-section-id="${this.id}"] .js-wishlist-page`,
				template: 'page',
				handle: window.WishlistKing.toolkit.settings.wishlistPageHandle,
			},
			(target) => {
				target.replace(window.WishlistKing.createComponent('wishlist-page'));
			},
		);
		window.WishlistKing.observe(
			{
				selector: `[data-section-id="${this.id}"] .js-wishlist-shared-page`,
				template: 'page',
				handle: window.WishlistKing.toolkit.settings.sharedWishlistPageHandle,
			},
			(target) => {
				target.replace(window.WishlistKing.createComponent('wishlist-page-shared'));
			},
		);
	},
	// onLoad: function () {
	// 	if (window.WishlistKing) {
	// 		this.initWishlistPage();
	// 	} else {
	// 		$('body').on('app:wishlistKing:ready', (e) => {
	// 			this.initWishlistPage();
	// 		});
	// 	}
	// },
});

Shopify.theme.sections.register('fixed-button-1', {
	onLoad: function () {
		this.extend(scrollButtonExtension);

		const $button = $(this.container).find('.js-fixed-button');
		if (!$button.length) return;

		const showTargetId = $button.attr('data-show-after-id');
		const $showTarget = $(`#${showTargetId}`);
		const hideTargetId = $button.attr('data-hide-after-id');
		const $hideTarget = $(`#${hideTargetId}`);

		const showButton = () => {
			$button.removeClass('is-hidden');
		};
		const hideButton = () => {
			$button.addClass('is-hidden');
		};

		if (!$showTarget.length) {
			showButton();
		}

		$(window).on('scroll resize', function () {
			const buttonTop = $button.offset().top + $button.outerHeight();

			if ($showTarget.length) {
				const showTop = $showTarget.offset().top;

				if (buttonTop >= showTop) {
					showButton();
				} else {
					hideButton();
				}
			}

			if ($hideTarget.length) {
				const hideTop = $hideTarget.offset().top;

				if (buttonTop >= hideTop) {
					hideButton();
				} else {
					showButton();
				}
			}
		});
	},
});

Shopify.theme.sections.register('stockist-app', {
	handleScrollToMap: function () {
		if ($(window).width() <= 768) {
			$(this.container).on('click', 'li.stockist-list-result', (e) => {
				scrollToElement(
					$(e.currentTarget).parents('#stockist-widget').find('.stockist-map'),
					300,
					-50,
				);
			});
		}
	},
	onLoad: function () {
		this.handleScrollToMap();
	},
});

Shopify.theme.sections.register('gdpr-banner', {
	handleExternalOpen: function () {
		$('body').on('theme:openGDPR', () => {
			this.openBanner();
		});
	},
	trackBannerVisibility: function () {
		const bannerElement = this.container.querySelector('#banner-wrapper');
		if (bannerElement === null) return;

		const observer = new MutationObserver(() => {
			if (window._GDPR_VAL && window._GDPR_VAL.global.bannerOpen) {
				this.onBannerOpen();
			} else {
				this.onBannerClose();
			}
		});
		observer.observe(bannerElement, { attributes: true, childList: false });
	},
	openBanner: function () {
		$(this.container).find('#cookie-banner_flag').click();
	},
	onBannerOpen: function () {
		if (window._GDPR_VAL && window._GDPR_VAL.global.bannerOpen) {
			$('body').trigger('theme:closeDrawer', ['all']);
			$('html').addClass('is-drawer-open');
		}
	},
	onBannerClose: function () {
		if (window._GDPR_VAL && !window._GDPR_VAL.global.bannerOpen) {
			$('body').trigger('theme:closeDrawer', ['all']);
			$('html').removeClass('is-drawer-open');
		}
	},
	onLoad: function () {
		this.trackBannerVisibility();
		this.handleExternalOpen();
	},
});

Shopify.theme.sections.register('slideshow-1', {
	initSlider: function () {
		const _this = this;
		const sliderElement = this.container.querySelector('.js-slider');
		this.swiper = new Swiper(sliderElement, {
			effect: 'fade',
			slidesPerView: 1,
			autoplay:
				this.settings['autoplay_delay'] > 0
					? {
							delay: this.settings['autoplay_delay'] * 1000,
							disableOnInteraction: false,
					  }
					: false,
			a11y: true,
			loop: true,
			keyboard: true,
			grabCursor: true,
			speed: 0,
			autoHeight: true,
			navigation: this.settings['is_enable_navigation']
				? {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
				  }
				: false,
			pagination: this.settings['is_enable_pagination']
				? {
						el: '.swiper-pagination',
						clickable: true,
				  }
				: false,
			on: {
				init: function (swiper) {
					$(swiper.slides[swiper.activeIndex]).addClass('is-active');
				},
				realIndexChange: function (swiper) {
					const $slides = $(swiper.slides);
					const $activeSlide = $(swiper.slides[swiper.activeIndex]);
					const $prevSlide = $(swiper.slides[swiper.previousIndex]);

					$activeSlide.addClass(_this.selectors.slideActiveClass);
					$slides.not($activeSlide).removeClass(_this.selectors.slideActiveClass);

					$prevSlide.addClass(_this.selectors.slidePrevClass);
					$slides.not($prevSlide).removeClass(_this.selectors.slidePrevClass);
				},
			},
		});
	},
	onLoad: function () {
		this.selectors = {
			slideActiveClass: 'is-active',
			slidePrevClass: 'is-prev',
		};
		this.settings = window.Shopify.theme.getSectionData(this.container);
		this.initSlider();
	},
});

Shopify.theme.sections.register('slideshow-2', {
	initSlider: function () {
		const _this = this;
		const sliderElement = this.container.querySelector('.js-slider');
		this.swiper = new Swiper(sliderElement, {
			effect: 'fade',
			slidesPerView: 1,
			autoplay:
				this.settings['autoplay_delay'] > 0
					? {
							delay: this.settings['autoplay_delay'] * 1000,
							disableOnInteraction: false,
					  }
					: false,
			a11y: true,
			loop: true,
			keyboard: true,
			grabCursor: true,
			speed: 0,
			autoHeight: true,
			navigation: this.settings['is_enable_navigation']
				? {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
				  }
				: false,
			pagination: this.settings['is_enable_pagination']
				? {
						el: '.swiper-pagination',
						clickable: true,
				  }
				: false,
			on: {
				init: function (swiper) {
					$(swiper.slides[swiper.activeIndex]).addClass('is-active');
				},
				realIndexChange: function (swiper) {
					const $slides = $(swiper.slides);
					const $activeSlide = $(swiper.slides[swiper.activeIndex]);
					const $prevSlide = $(swiper.slides[swiper.previousIndex]);

					$activeSlide.addClass(_this.selectors.slideActiveClass);
					$slides.not($activeSlide).removeClass(_this.selectors.slideActiveClass);

					$prevSlide.addClass(_this.selectors.slidePrevClass);
					$slides.not($prevSlide).removeClass(_this.selectors.slidePrevClass);
				},
			},
		});
	},
	onLoad: function () {
		this.selectors = {
			slideActiveClass: 'is-active',
			slidePrevClass: 'is-prev',
		};
		this.settings = window.Shopify.theme.getSectionData(this.container);
		this.initSlider();
	},
});

function setHeaderHeight(e) {
	const headerHeight = $('.l-header').outerHeight();
	const subheaderHeight = $('.l-subheader').outerHeight();
	const mainNavigationHeight = $('.l-header__header-navigation').is(':visible')
		? $('.l-header__header-navigation').outerHeight()
		: $('.l-header__header-navigation').get(0).clientHeight;

	$(':root').css({
		'--header-height-main': `${headerHeight}px`,
		'--header-height-subheader': `${subheaderHeight}px`,
		'--header-height-main-navigation': `${mainNavigationHeight}px`,
	});

	if (checkElementVisibility($('.l-subheader').get(0))) {
		$(':root').css('--header-height-total', `${headerHeight + subheaderHeight}px`);
	} else {
		$(':root').css('--header-height-total', `${headerHeight}px`);
	}
}
$(window).on('scroll resize load', debounce(setHeaderHeight, 300));
$('body').on('theme:drawerTransitionEnd theme:searchTransitionEnd', setHeaderHeight);

$(document).ready(function () {
	Shopify.theme.sections.load('*');

	// init scroll button
	/*(function() {
		$('body').on('click', '[href^="#"]', function(e) {
			e.preventDefault();
			const targetSelector = $(this).attr("href");
			scrollToSelector(targetSelector);
		})
	})();*/
});

$(window).on('load', function () {
	// init scroll on load
	(function () {
		if (window.location.hash.length) {
			const targetSelector = decodeURI(window.location.hash);
			scrollToSelector(targetSelector);
		}
	})();

    const selectVariant = () => {
       const options = document.querySelector(
          ".o-product-option-1__dropdown .o-product-option-1__dropdown-list"
        );
        const optionsList = options?.querySelectorAll(
          ".o-product-option-1__value-row"
        );
      
        if (optionsList?.length == 1) {
          optionsList[0].click();
        }
    }

  selectVariant()

  setTimeout(selectVariant, 1000)
   
});







$('body').on('theme:onCartItemAdd', (e, item, cartState) => {
	cart_update_forPixel()

	if (!item) item = e?.detail[0]
	if (!cartState) cartState = e?.detail[1]

	// console.log("+++ ===1 e", e)
	// console.log("+++ ===1 item", item)
	// console.log("+++ ===1 cartState", cartState)

	if (cartState) bloomreach_cart_update (e, item, cartState, 'add')
	if (!cartState) bloomreach_cart_update_2 (e, item, cartState, 'add')
})
$('body').on('theme:onCartItemRemove', (e, item, cartState) => {
	cart_update_forPixel()

	if (!item) item = e?.detail[0]
	if (!cartState) cartState = e?.detail[1]
	if (cartState) bloomreach_cart_update (e, item, cartState, 'remove')
	if (!cartState) bloomreach_cart_update_2 (e, item, cartState, 'remove')
})
$('body').on('theme:onCartItemUpdate', (e, item, cartState) => {
	cart_update_forPixel()

	if (!item) item = e?.detail[0]
	if (!cartState) cartState = e?.detail[1]
	if (cartState) bloomreach_cart_update (e, item, cartState, 'update')
	if (!cartState) bloomreach_cart_update_2 (e, item, cartState, 'update')
})
function bloomreach_cart_update (e, item, cartState, eventType) {
	const product_list = []
	const sku_list = []
	const product_id = item?.product_id
	let variant_ids = '';
	for (let i = 0; i < cartState.items.length; i++) {
		const item = cartState.items[i];
		product_list.push({"product_id": `${item.product_id}`, "quantity": item.quantity})
		sku_list.push({ "sku": `${item.sku}`,  "quantity": item.quantity })
		variant_ids += `${variant_ids ? ', ' : ''}${item.id}`
	}
	product_list.reverse()
	const mainCartData = {
		action: eventType ? eventType : 'update',
		product_list: product_list,	
		sku_list: sku_list,	
		total_quantity: cartState.item_count,
		total_price: cartState.total_price / 100,
		total_price_local_currency: cartState.total_price / 100,
		language: Shopify.locale,
		variant_ids: variant_ids,
		location: window.location.href,
		local_currency: Shopify.currency.active,
		page_type: gl_page_type
	}
	let oneItemCartData = {}
	if (item && item?.properties?._bloomreach_product_json) {
		oneItemCartData = JSON.parse(item.properties._bloomreach_product_json)
		oneItemCartData.original_price = oneItemCartData.price;
		oneItemCartData.original_price_local_currency = oneItemCartData.price;
		if (oneItemCartData.compare_at_price && Number(oneItemCartData.compare_at_price) > Number(oneItemCartData.original_price) ) {
			oneItemCartData.discount_percentage = Math.round(Number(oneItemCartData.original_price) / Number(oneItemCartData.compare_at_price) * 100);
			oneItemCartData.discount_value = oneItemCartData.compare_at_price - oneItemCartData.original_price;
		}
	}
	if (gl_current_tax) {
		let total_price_without_tax = mainCartData.total_price * gl_current_tax / 100
		oneItemCartData.total_price_without_tax =  mainCartData.total_price - total_price_without_tax
	}


	// BTN DATA
	var btnData = {};
	if (product_id && eventType == 'add') {
		btnData.button_type = $('#product_form_'+product_id+' .js-product-sticky').hasClass('is-open') ? 'Add to cart overlay' : 'Product'
		btnData.button_copy = $('#product_form_'+product_id+' button.js-cart-button[type="submit"] .o-button-solid__text').first().text().trim();
	}
	if (eventType == 'remove') {
		btnData.button_type = 'remove'
		btnData.button_copy =  $("body").hasClass("template-cart") ? "Cart" : "Ajax Cart"
	}
	if (eventType == 'update') {
		btnData.button_type = 'update'
		btnData.button_copy =  $("body").hasClass("template-cart") ? "Cart" : "Ajax Cart"
	}

	
    exponea.track('cart_update', {
        ...mainCartData,
		...oneItemCartData,
		...btnData
    });
	// console.log('+++ === cart_update ');
	// console.log('+++ === mainCartData ', mainCartData);
	// console.log('+++ === oneItemCartData ', oneItemCartData);
	// console.log('+++ === btnData ', btnData);
	
}	


async function bloomreach_cart_update_2(e, item, cartState, eventType) {
	const response = await fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET', });
	const data = await response.json();
	// console.log(data);
	bloomreach_cart_update (e, item, data, eventType)
} 



async function cart_update_forPixel() {
	const response = await fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET', });
	const data = await response.json();
	localStorage.setItem("theCartPixel", JSON.stringify(data))
} 


/* ==========================================================================
   NATIVE REAL-TIME BLUR VALIDATION - ALL .o-form-1 native forms
   Explicitly excluded: .o-cf-form / .cf-form-inner (Customer Fields React App)
   ========================================================================== */
document.addEventListener("DOMContentLoaded", function () {

    function validateField(field) {
        var inputWrapper = field.closest('.o-form-1__input');
        var inputWrap = field.closest('.o-form-1__input-wrap');
        if (!inputWrapper || !inputWrap) return;

        var existing = inputWrap.querySelector('.tb-field-error');
        if (existing) existing.remove();

        if (!field.value.trim()) {
            var errMsg = document.createElement('span');
            errMsg.className = 'tb-field-error';
            errMsg.style.cssText = 'display:block;color:#EB001B;font-size:12px;margin-top:4px;';
            errMsg.textContent = document.documentElement.dir === 'rtl' ? '\u0647\u0630\u0627 \u0627\u0644\u062d\u0642\u0644 \u0645\u0637\u0644\u0648\u0628.' : 'This field is required.';
            inputWrapper.insertAdjacentElement('afterend', errMsg);
        }
    }

    function attachNativeValidation() {
        var inputs = document.querySelectorAll(
            '.o-form-1 input[type="text"],' +
            '.o-form-1 input[type="email"],' +
            '.o-form-1 input[type="password"],' +
            '.o-form-1 input[type="tel"]'
        );

        inputs.forEach(function (input) {
            if (input.type === 'hidden' || input.type === 'checkbox' || input.type === 'radio') return;
            if (input.closest('.o-cf-form') || input.closest('.cf-form-inner')) return;
            if (input.dataset.nativeBlurAttached) return;
            input.dataset.nativeBlurAttached = 'true';

            input.addEventListener('blur', function () { validateField(this); });
            input.addEventListener('input', function () {
                var inputWrap = this.closest('.o-form-1__input-wrap');
                if (inputWrap && inputWrap.querySelector('.tb-field-error')) {
                    validateField(this);
                }
            });
        });
    }

    function attachNumericKeyboard() {
        var nativeInputs = document.querySelectorAll(
            '.o-form-1 input[name="address[phone]"],' +
            '.o-form-1 input[name="address[zip]"],' +
            '.o-form-1 input[type="tel"]'
        );
        nativeInputs.forEach(function (input) {
            if (input.closest('.o-cf-form') || input.closest('.cf-form-inner')) return;
            if (!input.hasAttribute('inputmode')) {
                input.setAttribute('inputmode', 'numeric');
            }
        });

        var cfPhoneInputs = document.querySelectorAll(
            '.cf-phone-field input,' +
            '[data-cf-field-type="phone"] input,' +
            '[data-cf-column-key="phone"]'
        );
        cfPhoneInputs.forEach(function (input) {
            if (!input.hasAttribute('inputmode')) {
                input.setAttribute('inputmode', 'numeric');
            }
        });
    }

    attachNativeValidation();
    attachNumericKeyboard();

    var observer = new MutationObserver(function () {
        attachNativeValidation();
        attachNumericKeyboard();
    });
    observer.observe(document.body, { childList: true, subtree: true });
});